import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2 mx-2"},[(
      _vm.analysisFast !== '∞' ||
      _vm.aiFeedbackFast !== '∞' ||
      _vm.liveTranscriptionFast !== '∞'
    )?_c(VBtn,{attrs:{"color":"primary","width":"100%","to":_vm.hasSubscription ? '/settings' : '/subscription/pricing'}},[_vm._v(_vm._s(_vm.$t("quota.upgrade")))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }